/* ============================================================
   Fotorecord Configuratori — Modulo Pricing Condiviso
   SSOT: scripts/price_logic.py
   Deve essere caricato PRIMA di qualsiasi configuratore.js
   ============================================================ */
(function () {
  'use strict';

  const FR = window.FOTORECORD = window.FOTORECORD || {};
  FR.INSTANCES = FR.INSTANCES || {};

  /* >>> PRICING_SSOT — generato da generate_pricing_constants_js.py · NON modificare a mano >>> */
  /* Fonte unica: src/price_logic.py + database/db_costi_fissi.csv (prezzo clip).
     I configuratori leggono da qui (Object.assign) invece di hardcodare i numeri. */
  FR.PRICING_SSOT = {
    IVA:                                    0.22,
    SPEDIZIONE:                             12.9,
    SOGLIA_SPEDIZIONE_GRATUITA:             250,
    SOGLIA_SUPPLEMENTO_CM:                  60,
    SOGLIA_SOLO_PREVENTIVO_CM:              105,
    SOGLIA_CRILEX_CM:                       70,
    SUPPLEMENTO_IMBALLO_NETTO:              16.39,
    SUPPLEMENTO_IMBALLO_IVA:                20,
    KIT_MONTAGGIO_ASTA_L_NETTO:             8.2,
    KIT_MONTAGGIO_ASTA_L_IVA:               10,
    ARIA_ASTA_L_A_MM:                       3,
    ARIA_ASTA_L_B_MM:                       10,
    ARIA_ASTA_L_LARGA_MM:                   18,
    APPOGGIO_VITE_MIN_MM:                   12,
    TELA_ASTA_L_LATO_MIN_CM:                20,
    TELA_ASTA_L_LATO_MAX_CM:                60,
    TELAIO_NOSTRA_TELA_MM:                  15,
    TELA_SPESSORE_MM:                       1,
    SOGLIA_CLIP_LATO_MIN:                   35,
    SOGLIA_CLIP_LATO_MAX:                   50,
    N_CLIPS_STD:                            4,
    N_CLIPS_GRANDE:                         8,
    N_CLIPS_PER_SIDE_STD:                   1,
    N_CLIPS_PER_SIDE_GR:                    2,
    SOGLIA_ATTACCAGLIE_CM:                  40,
    N_ATTACCAGLIE_STD:                      1,
    N_ATTACCAGLIE_GRANDE:                   2,
    ABBONDANZA_TELA_CM:                     2,
    BATTENTE_MIN_TELA_MM:                   20,
    PP_LEGNO_MIN_BATTENTE_MM:               20,
    PASSEPARTOUT_CARTONE_LARGH_MIN_CM:      2.5,
    PASSEPARTOUT_CARTONE_LARGH_MAX_CM:      20,
    PASSEPARTOUT_CARTONE_LARGH_DEFAULT_CM:  2.5,
    MDF_TAVOLO_MAX_BASE_CM:                 24,
    MDF_TAVOLO_MAX_ALTEZZA_CM:              30,
    PROF_CM:                                1.4,
    COSTO_CLIP:                             0.0819672131147541,
    SORMONTO_CM:                            0.3,
    GIOCO_CORNICE_CM:                       0.3,
    GIOCO_TELA_CM:                          0.6,
    TELAIO_TELA_LARGH_CM:                   4.3,
    TELAIO_TELA_SPESS_CM:                   1.5,
    TELAIO_TELA_COSTO_ML:                   1.65,
    TELAIO_TELA_MARKUP:                     2.9,
    TELAIO_TELA_MARKUP_GRANDE:              3.5,
    LAVORAZIONE_FINESTRA_PM_LORDO:          1,
  };
  /* <<< PRICING_SSOT <<< */

  /* Imballo formato grande, NETTO — da sommare a un imponibile.
     `fascia.supplementoGrande` arriva dal metaobject spedizioni_configuratore, che porta
     il valore IVA INCLUSA (20,00 €: quello che paga il cliente, ed è anche quello che si
     mostra a schermo). Sommarlo così com'era a un imponibile lo faceva diventare 24,40 €
     a scaffale — corretto il 29/07/2026. SSOT: price_logic.SUPPLEMENTO_IMBALLO_IVA. */
  FR.imballoNetto = function (fascia) {
    const lordo = (fascia && fascia.supplementoGrande) || 0;
    return lordo / (1 + FR.PRICING_SSOT.IVA);
  };

  /* ── NON PIÙ USATO (Mantenuto vuoto per retrocompatibilità) ── */
  FR.PRICING_DEFAULTS = {};

  /* ── COLORE SURROGATO DEL PROFILO (SSOT) ──────────────────────────────────
     Colore usato quando la foto dell'asta manca o non carica: render live del
     configuratore, swatch dei filtri del quiz, fill delle thumbnail.
     Una mappa sola, perché nei dati convivono due vocabolari:
     · tassonomia `colore` di db_metro_lineare.csv — blu, verde, viola…
     · essenze e finiture, che arrivano da `finitura`/`nome` — noce, rovere…
     Tenerne due separate ha già prodotto un bug silenzioso: chi guardava solo
     le essenze rendeva marrone ogni profilo colorato (302 profili su 487). */
  FR.COLOR_MAP = {
    /* tassonomia `colore` */
    'bianco':    '#F0EDE8',
    'beige':     '#D8C6A6',
    'grigio':    '#8A8A8A',
    'nero':      '#2C2C2C',
    'argento':   '#C0C0C0',
    'oro':       '#B8860B',
    'giallo':    '#E8C13A',
    'arancione': '#E07B2A',
    'rosso':     '#B5302A',
    'bordeaux':  '#6E1F2C',
    'rosa':      '#E0A6BA',
    'viola':     '#7B4A8C',
    'blu':       '#2E4F8E',
    'verde':     '#3C7A4A',
    'marrone':   '#6B4A2A',
    /* essenze e finiture */
    'noce':      '#6B4A1A',
    'ciliegio':  '#7A2020',
    'mogano':    '#5C1F0F',
    'teak':      '#A0622D',
    'anticato':  '#7A6040',
    'bronzo':    '#8C6A3A',
    'rame':      '#B87333',
    'naturale':  '#C8A060',
    'pino':      '#C8A96E',
    'rovere':    '#9B7A4A',
    'wenge':     '#4A3020',
    'laccato':   '#E8E0D5',
  };

  /* Chiavi per il match parziale, dalla più lunga alla più corta: su un nome
     come "noce anticato" deve vincere la chiave più specifica, non quella
     scritta prima — l'ordine di un object literal non è un criterio. */
  const _COLOR_KEYS = Object.keys(FR.COLOR_MAP).sort((a, b) => b.length - a.length);

  /* Hex per un nome colore/essenza: match esatto, poi parziale. */
  FR.coloreHex = function (nome, fallback) {
    const k = (nome || '').toLowerCase().trim();
    if (!k) return fallback;
    if (FR.COLOR_MAP[k]) return FR.COLOR_MAP[k];
    for (const key of _COLOR_KEYS) { if (k.includes(key)) return FR.COLOR_MAP[key]; }
    return fallback;
  };

  /* Perimetro ESTERNO della cornice (m): perimetro interno + sfrido dei tagli a 45°.
     Gli 8×larghezza_sezione sono il materiale consumato dai 4 angoli mitrati.
     SSOT: price_logic.calculate_external_perimeter (Python).
     sezioneMm = larghezza della sezione del profilo in mm. */
  FR.perimEsternoM = function (baseCm, altCm, sezioneMm) {
    return 2 * (baseCm + altCm) / 100 + 8 * ((sezioneMm || 0) / 1000);
  };

  /* ── Catena dei sormonti (SSOT: price_logic.py, stessi nomi/formule; lessico in
     docs/glossario_tecnico_cornici.md) ──
     Ogni strato copre SORMONTO_CM per lato dell'elemento interno:
     cornice → [pp legno] → [pp cartone] → opera.
     - luce = opera − 2×SORMONTO (la parte dell'opera a vista, con o senza passepartout)
     - cartone: esterno = luce + 2×(dimensione+SORMONTO) → dimensione visibile = inserita,
       aggiunge 2×dimensione esatti alla misura esterna
     - legno: larghezza fissa → dimensione visibile = larghezza − SORMONTO,
       aggiunge 2×larghezza − 2×SORMONTO
     - pacco (dimsPacco) = esterno dello strato più esterno: taglio di vetro e fondo, soglie;
       interno cornice (dimsBattente, nome storico) = pacco + gioco di montaggio;
       esterno = interno − 2×SORMONTO + 2×sezione */

  /* Apertura di uno strato sull'elemento interno (sight size, per asse): sull'opera e' la luce. */
  FR.sightCm = function (cm) { return cm - 2 * FR.PRICING_SSOT.SORMONTO_CM; };

  /* Gioco di montaggio, totale per asse (SSOT: price_logic.gioco_montaggio_cm). */
  FR.giocoCm = function (tela) {
    return tela ? FR.PRICING_SSOT.GIOCO_TELA_CM : FR.PRICING_SSOT.GIOCO_CORNICE_CM;
  };

  /* Misura del pacco {b, h} in cm: opera + catena passepartout (SSOT: price_logic.dims_pacco). */
  FR.dimsPacco = function (baseCm, altCm, ppCartoneLarghCm, ppLegnoLarghMm) {
    let b = baseCm, h = altCm;
    const s = FR.PRICING_SSOT.SORMONTO_CM;
    if (ppCartoneLarghCm > 0) { b += 2 * ppCartoneLarghCm; h += 2 * ppCartoneLarghCm; }
    if (ppLegnoLarghMm > 0) {
      const L = ppLegnoLarghMm / 10;
      b += 2 * L - 2 * s; h += 2 * L - 2 * s;
    }
    return { b, h };
  };

  /* Interno della cornice {b, h} in cm: pacco + gioco (SSOT: price_logic.dims_battente). */
  FR.dimsBattente = function (baseCm, altCm, ppCartoneLarghCm, ppLegnoLarghMm, giocoCm) {
    const p = FR.dimsPacco(baseCm, altCm, ppCartoneLarghCm, ppLegnoLarghMm);
    const g = giocoCm == null ? FR.giocoCm(false) : giocoCm;
    return { b: p.b + g, h: p.h + g };
  };

  /* Misure interne (finestra) del pp legno: cartone esterno (se presente) o opera, − sormonto. */
  FR.ppLegnoInterne = function (baseCm, altCm, ppCartoneLarghCm) {
    const s = FR.PRICING_SSOT.SORMONTO_CM;
    let b = baseCm, h = altCm;
    if (ppCartoneLarghCm > 0) { b += 2 * ppCartoneLarghCm; h += 2 * ppCartoneLarghCm; }
    return { b: b - 2 * s, h: h - 2 * s };
  };

  /* Area (m²) dell'anello fisico del pp cartone: esterno − luce (SSOT: area_pp_cartone_mq). */
  FR.areaPpCartoneMq = function (baseCm, altCm, larghCm) {
    const s = FR.PRICING_SSOT.SORMONTO_CM;
    const outB = baseCm + 2 * larghCm, outH = altCm + 2 * larghCm;
    return (outB * outH - (baseCm - 2 * s) * (altCm - 2 * s)) / 10000;
  };

  /* Fascia dimensionale del pezzo, dal lato maggiore. Mirror JS di
     price_logic.get_fascia_dimensionale — soglie e imballo da PRICING_SSOT.

     Dal 30/07/2026 NON legge più il metaobject `spedizioni_configuratore` (ritirato con
     database/db_spedizioni.csv): quel metaobject portava le soglie 60/105 e i 20,00 di
     imballo, cioè valori che stanno già qui sopra in PRICING_SSOT, generato da
     price_logic. Era una seconda copia degli stessi numeri, sincronizzata a mano, con il
     rischio in più delle voci DRAFT invisibili in Liquid (guardrail #11). Il parametro
     `spedizioniArray` è ignorato: resta nella firma perché i call site lo passano ancora
     e togliere l'argomento non cambierebbe nulla di sostanza.

     `isGrande` è ESPLICITO. Prima ogni consumatore lo deduceva con
     `fascia.supplementoGrande > 0`, usando l'importo dell'imballo come spia della fascia:
     se l'imballo andasse a 0 (promo, ritiro, listino nuovo) tutte le regole "grande" —
     markup per-componente compreso — si spegnerebbero in silenzio. Una soglia si misura,
     non si indovina da un prezzo.

     `costoSpedizione` resta 0: il trasporto a video lo prende da PRICING_SSOT.SPEDIZIONE.
     Online l'extra large non si prezza (> 105 cm = solo preventivo), quindi la tariffa
     extra large di price_logic qui non serve. */
  /* ── Markup PER-COMPONENTE: un solo lettore per tutti i configuratori e il quiz.
        Ogni voce porta markup (std) e markupGrande (fascia grande); un componente senza
        markup si REGISTRA in mk.mancanti, e chi calcola non deve emettere un prezzo
        (ConfiguratoreBase._markupMancante). `ereditaDa` e' la voce da cui una fascia
        (es. stampa foto small/pro) puo' legittimamente ereditare. Accetta anche la
        forma snake_case `markup_grande` dei profili di ASTE_CORNICI_FULL. ── */
  FR.makeMk = function (isGrande) {
    const mancanti = [];
    const val = (x) => {
      if (!x) return 0;
      const g = (x.markupGrande != null ? x.markupGrande : x.markup_grande);
      return isGrande ? (g || x.markup) : x.markup;
    };
    const mk = (c, ereditaDa) => {
      if (!c) return 0;
      const v = val(c) || val(ereditaDa);
      if (!v) mancanti.push(c.nome || c.sku || '?');
      return v || 0;
    };
    mk.mancanti = mancanti;
    return mk;
  };

  /* ── LA FORMULA DELLA CORNICE SU MISURA, una sola (12/09/2026). Fino ad allora viveva
        in ConfiguratoreAste.calculateLive e, copiata, nel quiz (`_calcPrezzo`), con le
        prime divergenze gia' dentro (imballo come `supplementoGrande` grezzo, attaccaglie
        con un 2,9 di ripiego). Specchio di price_engine.calcola_cornice: perimetro sul
        BATTENTE per asta, fronte e retro; passepartout legno sul perimetro interno;
        cartone sull'anello; stampa foto sull'opera, tela su tela + telaio 43T.
        Input normalizzati (costoMl, costoMq, larghezzaMm); ritorna i NETTI per voce. ── */
  FR.corniceNetto = function (o) {
    const P  = o.P || FR.PRICING_SSOT;
    const mk = o.mk;
    const ppcLargh = (o.passCartone && o.passCartoneLargh > 0) ? o.passCartoneLargh : 0;
    const pplMm    = o.passLegno ? (o.passLegno.larghezzaMm || 0) : 0;
    const pacco    = FR.dimsPacco(o.base, o.altezza, ppcLargh, pplMm);
    const batt     = FR.dimsBattente(o.base, o.altezza, ppcLargh, pplMm,
                                     FR.giocoCm(o.tela || o.stampaTipo === 'tela'));
    const areaMq     = o.base * o.altezza / 10000;
    const areaBattMq = pacco.b * pacco.h / 10000;

    const asta   = (o.profilo?.costoMl || 0) * FR.perimEsternoM(batt.b, batt.h, o.profilo?.larghezzaMm) * mk(o.profilo);
    const fronte = (o.fronte?.costoMq || 0) * areaBattMq * mk(o.fronte);
    const retro  = (o.retro?.costoMq  || 0) * areaBattMq * mk(o.retro);

    let passLegno = 0;
    if (o.passLegno) {
      const pplInt = FR.ppLegnoInterne(o.base, o.altezza, ppcLargh);
      passLegno = (o.passLegno.costoMl || 0) * FR.perimEsternoM(pplInt.b, pplInt.h, o.passLegno.larghezzaMm) * mk(o.passLegno);
    }
    let passCartone = 0;
    if (o.passCartone && ppcLargh > 0) {
      passCartone = (o.passCartone.costoMq || 0) * FR.areaPpCartoneMq(o.base, o.altezza, ppcLargh) * mk(o.passCartone);
    }
    let stampa = 0;
    if (o.stampa && o.stampaTipo) {
      if (o.stampaTipo === 'tela') {
        const baseTela = o.base    + 2 * P.TELAIO_TELA_SPESS_CM + 2 * P.ABBONDANZA_TELA_CM;
        const altTela  = o.altezza + 2 * P.TELAIO_TELA_SPESS_CM + 2 * P.ABBONDANZA_TELA_CM;
        const mkTelaio = o.isGrande ? P.TELAIO_TELA_MARKUP_GRANDE : P.TELAIO_TELA_MARKUP;
        const mlTelaio = FR.perimEsternoM(
          o.base - 2 * P.TELAIO_TELA_LARGH_CM, o.altezza - 2 * P.TELAIO_TELA_LARGH_CM,
          P.TELAIO_TELA_LARGH_CM * 10);
        stampa = (baseTela * altTela / 10000) * (o.stampa.costoMq || 0) * mk(o.stampa)
               + mlTelaio * P.TELAIO_TELA_COSTO_ML * mkTelaio;
      } else {
        stampa = areaMq * (o.stampa.costoMq || 0) * mk(o.stampa);
      }
    }
    /* attaccaglie: `prezzo` e' il prezzo di vendita IVA inclusa per pezzo
       (accessori_configuratore), riportato a netto */
    const accessori = (o.attaccaglie || []).reduce((sum, a) => {
      const unit = (Number(a.prezzo) || 0) / (1 + P.IVA);
      return sum + (a.qty || 0) * unit;
    }, 0);

    const netto = asta + fronte + retro + passLegno + passCartone + stampa + accessori;
    return { asta, fronte, retro, passLegno, passCartone, stampa, accessori, netto, batt };
  };

  /* ── PASSEPARTOUT MULTIFOTO (ADR 09/10/2026). Specchio di
        price_engine.calcola_passepartout_multifoto: il cartone si paga sull'AREA TOTALE
        del passepartout (finestre comprese) col ricarico della fascia del passepartout, e
        la lavorazione delle finestre e' IVA compresa, riportata a netto e fuori dal
        ricarico. La cornice attorno si calcola con FR.corniceNetto, con l'opera grande
        quanto il passepartout e senza cartone ad anello. Ritorna i NETTI. ── */
  FR.passepartoutMultifotoNetto = function (o) {
    const P = o.P || FR.PRICING_SSOT;
    const cartone = (o.passCartone?.costoMq || 0) * (o.base * o.altezza / 10000) * o.mk(o.passCartone);
    const lavorazione = (o.nFinestre || 0) * P.LAVORAZIONE_FINESTRA_PM_LORDO / (1 + P.IVA);
    return { cartone, lavorazione };
  };

  /* Il conto INTERO di un passepartout multifoto, quello che fa il configuratore
     (ConfiguratoreMultifoto.calculateLive) e che prova la parita' col motore Python
     (tests/test_parita_passepartout_multifoto.py): una funzione sola, cosi' il test misura
     il conto del sito e non una sua ricomposizione. base/altezza = il passepartout. */
  FR.passepartoutMultifotoTotale = function (o) {
    const P = o.P || FR.PRICING_SSOT;
    const fascia = FR.getFascia(o.base, o.altezza);
    const mk = FR.makeMk(fascia.isGrande);
    const voci = FR.corniceNetto({
      base: o.base, altezza: o.altezza, profilo: o.profilo, fronte: o.fronte, retro: o.retro,
      passLegno: o.passLegno || null, passCartone: null, passCartoneLargh: 0, stampa: null, stampaTipo: null,
      attaccaglie: o.attaccaglie || [], isGrande: fascia.isGrande, mk, P,
    });
    const pm = FR.passepartoutMultifotoNetto({ base: o.base, altezza: o.altezza, passCartone: o.passCartone,
                                               nFinestre: o.nFinestre, mk, P });
    const imponibile = voci.netto + pm.cartone + pm.lavorazione + FR.imballoNetto(fascia);
    return { fascia, mk, voci, pm, imponibile, prezzoUnitario: imponibile * (1 + P.IVA) };
  };

  /* ── CORNICI CON ASTE A L (ADR 2026-10-12). Specchio di price_engine.calcola_asta_l e
        delle regole di price_logic «aste a L»: la misura e' la TELA, il canale e' tela +
        2×aria, l'esterno canale + 2×parete (nessun sormonto: la tela resta a vista); asta
        sul perimetro del canale piu' lo sfrido (8×base dell'asta, larghezzaMm); niente
        fronte, retro, passepartout; attaccaglie sul canale; kit di montaggio a scelta,
        netto fisso fuori dal ricarico. Il profilo porta pareteMm, larghezzaBattenteMm
        (fondo) e ariaImpostaMm. Ritorna i NETTI per voce. ── */
  FR.arieAmmesseAstaL = function (profilo, P) {
    P = P || FR.PRICING_SSOT;
    const imposta = Number(profilo?.ariaImpostaMm) || 0;
    if (imposta > 0) return [imposta];
    const out = [P.ARIA_ASTA_L_A_MM, P.ARIA_ASTA_L_B_MM];
    if ((Number(profilo?.larghezzaBattenteMm) || 0) - P.ARIA_ASTA_L_LARGA_MM >= P.APPOGGIO_VITE_MIN_MM) out.push(P.ARIA_ASTA_L_LARGA_MM);
    return out;
  };
  FR.dimsAstaL = function (telaB, telaH, ariaMm, pareteMm) {
    const a = ariaMm / 10, p = pareteMm / 10;
    const ib = telaB + 2 * a, ih = telaH + 2 * a;
    return { internoB: ib, internoH: ih, esternoB: ib + 2 * p, esternoH: ih + 2 * p };
  };
  FR.telaAstaLAmmessa = function (telaB, telaH, P) {
    P = P || FR.PRICING_SSOT;
    return Math.min(telaB, telaH) >= P.TELA_ASTA_L_LATO_MIN_CM && Math.max(telaB, telaH) <= P.TELA_ASTA_L_LATO_MAX_CM;
  };
  FR.astaLNetto = function (o) {
    const P  = o.P || FR.PRICING_SSOT;
    const mk = o.mk;
    const d = FR.dimsAstaL(o.base, o.altezza, o.ariaMm, o.profilo?.pareteMm || 0);
    const asta = (o.profilo?.costoMl || 0) * FR.perimEsternoM(d.internoB, d.internoH, o.profilo?.larghezzaMm) * mk(o.profilo);
    const accessori = (o.attaccaglie || []).reduce((sum, a) => sum + (a.qty || 0) * ((Number(a.prezzo) || 0) / (1 + P.IVA)), 0);
    const kit = o.kit ? P.KIT_MONTAGGIO_ASTA_L_NETTO : 0;
    const netto = asta + accessori + kit;
    return { asta, accessori, kit, netto, d };
  };

  /* Quante attaccaglie automatiche: si misura il BATTENTE (opera + passepartout), come
     price_logic.get_hangers_count sul battente in price_engine. Una regola, un lettore:
     ConfiguratoreAste._nAttaccaglie e i ponti di parita'. */
  FR.nAttaccaglie = function (base, altezza, ppcLarghCm, pplMm, P) {
    P = P || FR.PRICING_SSOT;
    if (!base || !altezza) return P.N_ATTACCAGLIE_STD;
    const batt = FR.dimsPacco(base, altezza, ppcLarghCm || 0, pplMm || 0);
    return (batt.b > P.SOGLIA_ATTACCAGLIE_CM || batt.h > P.SOGLIA_ATTACCAGLIE_CM)
      ? P.N_ATTACCAGLIE_GRANDE : P.N_ATTACCAGLIE_STD;
  };

  FR.getFascia = function (baseCm, altCm, spedizioniArray) {
    const P = FR.PRICING_SSOT;
    const lmax = Math.max(baseCm, altCm);
    const imballo = P.SUPPLEMENTO_IMBALLO_IVA;
    if (lmax > P.SOGLIA_SOLO_PREVENTIVO_CM) {
      return { id: 'solo_preventivo', sogliaMax: 999, costoSpedizione: 0,
               supplementoGrande: imballo, soloPreventivo: true, isGrande: true };
    }
    if (lmax > P.SOGLIA_SUPPLEMENTO_CM) {
      return { id: 'grande', sogliaMax: P.SOGLIA_SOLO_PREVENTIVO_CM, costoSpedizione: 0,
               supplementoGrande: imballo, soloPreventivo: false, isGrande: true };
    }
    return { id: 'normale', sogliaMax: P.SOGLIA_SUPPLEMENTO_CM, costoSpedizione: 0,
             supplementoGrande: 0, soloPreventivo: false, isGrande: false };
  };

  /* ── REGOLE DI COMPATIBILITA', un solo lettore per configuratore e quiz (21/09/2026).
        Fino ad allora il quiz misurava il limite del retro da tavolo sulla sola opera
        (sesta copia della regola: guardrail #13) e non conosceva il vincolo Crilex. Le
        due funzioni sono lo specchio di price_logic.mdf_tavolo_consentito e della
        policy Crilex (docs/azienda/spedizioni-policy.md, SOGLIA_CRILEX_CM); ogni cancello
        di UI chiede a loro, non ridecide (guardrail #27). ── */

  /* Il retro `retro` regge il formato FINITO (battente: opera + passepartout), anche
     ruotato? Un retro senza limite dichiarato (maxBase assente o sentinella 999) e'
     sempre consentito; senza misure non si blocca a vuoto. */
  FR.retroConsentito = function (retro, baseCm, altCm, ppCartoneLarghCm, ppLegnoLarghMm) {
    if (!retro || !(retro.maxBase > 0) || retro.maxBase >= 999) return true;
    if (baseCm == null || altCm == null || isNaN(baseCm) || isNaN(altCm)) return true;
    const maxB = retro.maxBase;
    const maxA = (retro.maxAltezza > 0) ? retro.maxAltezza : 999;
    const fin  = FR.dimsPacco(baseCm, altCm, ppCartoneLarghCm || 0, ppLegnoLarghMm || 0);
    return (fin.b <= maxB && fin.h <= maxA) || (fin.b <= maxA && fin.h <= maxB);
  };

  /* Oltre SOGLIA_CRILEX_CM di lato il vetro non si spedisce e il fronte DEVE essere
     Crilex: e' una policy, quindi esce come errore che blocca il carrello. Ritorna il
     messaggio, o null se il vincolo non si applica. Riconoscimento tollerante su
     tipo/nome/sku, non `tipo === 'crilex'`: il campo `tipo` non e' garantito da tutte le
     sorgenti (tools/pricing/parita_js_blob.js costruisce i fronti con `tipo || 'vetro'`)
     e la forma pubblica e' «Crilex (plexiglass)», entrambe le parole devono contare. */
  FR.vincoloCrilex = function (fronte, baseCm, altCm) {
    const soglia = FR.PRICING_SSOT.SOGLIA_CRILEX_CM;
    if (!soglia || !baseCm || !altCm || isNaN(baseCm) || isNaN(altCm)) return null;
    if (Math.max(baseCm, altCm) <= soglia) return null;
    /* fronte non ancora risolto (dati in caricamento) o «Nessuno»: niente da vincolare. */
    if (!fronte) return null;
    const etichetta = [fronte.tipo, fronte.nome, fronte.sku].join(' ').toLowerCase();
    if (/crilex|plexi/.test(etichetta)) return null;
    return 'Oltre ' + soglia + ' cm di lato il fronte deve essere in Crilex: '
         + 'il vetro non è spedibile a questo formato.';
  };

  FR.applyPricingOverrides = function (pricing, overrides) {};

  /* Colore hex fallback per un profilo; fallback opzionale come secondo argomento */
  FR.getProfiloColor = function (profilo, fallback) {
    if (!profilo) return fallback || '#C8B89A';
    return FR.coloreHex(profilo.colore || profilo.nome, fallback || '#C8B89A');
  };

})();
